import cn from 'classnames'
import { observer } from 'mobx-react'
import React from 'react'

import { useCustomT } from '@flowwai-frontend/shared/common-components'

import { theme } from '../../theme'
import './index.css'
import * as Styles from './styles'

interface Props {
   logoUrl: string
   logoWidth: number
   title: string
   copyrightsText: string
}

const LaunchingModeMobileViewUI = (props: Props): React.ReactElement => {
   const { logoUrl, logoWidth, title, copyrightsText } = props

   const t = useCustomT('client:appMode.launchingMode')

   const themes = theme.launchMode

   const renderBody = () => (
      <div className={Styles.bodyContainerStylesMobileView}>
         <img
            alt='Launching Logo'
            src={logoUrl}
            style={{
               width: `${logoWidth}px`,
               marginTop: '40px',
               marginBottom: '86px'
            }}
         />
         <p className={cn(Styles.titleStylesMobileView, themes.titleTextColor)}>
            {title}
         </p>
         <p
            className={cn(
               Styles.descriptionStylesMobileView,
               themes.descriptionTextColor
            )}
         >
            {t('launchingSoon')}
         </p>
      </div>
   )

   const renderFooter = () => (
      <p
         className={cn(
            Styles.footerTextStylesMobileView,
            themes.footerTextColor
         )}
      >
         {copyrightsText}
      </p>
   )

   return (
      <div
         className={cn(Styles.containerStylesMobileView, themes.defaultBgColor)}
         style={{
            backgroundImage:
               "url('./assets/clientImages/launch_mode_mobile_bg.png')",
            backgroundSize: 'cover',
            backgroundPosition: 'center bottom 64px'
         }}
      >
         {renderBody()}
         {renderFooter()}
      </div>
   )
}

export default observer(LaunchingModeMobileViewUI)
